import { type BaggageInfo, type CabinClassRequest } from '@clients/FlightApi';
import { type TripPackageLoaderConfig } from '@itinerary/trip/types';

export enum FlightStatus {
    Ok = 'Ok',
    Delayed = 'Delayed',
    Cancelled = 'Cancelled',
}

export interface FlightPackageLoaderConfig extends TripPackageLoaderConfig {
    adultCount: number;
    childCount: number;
    infantCount: number;
    cabinClass?: CabinClassRequest;
    returnDate?: Date;
    isForeign?: boolean;
    isCapacityTrackCampaign?: boolean;
    token?: string;
    xplayerID?: string;
}

interface BaggageDetail extends BaggageInfo {
    paxTitle: string;
}

export interface FlightBaggageDetails {
    cabin: BaggageDetail[];
    baggage: BaggageDetail[];
}
